import React from "react";
import { element, arrayOf, string } from "prop-types";
import { Content } from "./compositionComponents/Content";
import { Header } from "./compositionComponents/Header";
import { Item } from "./compositionComponents/Item";
export var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    CustomTag = _ref.as,
    dataSpacer = _ref.dataSpacer,
    className = _ref.className;
  var childrenArray = React.Children.toArray(children);
  var HeaderChild;
  var ContentChild;
  // Check if the first child is a Header, otherwise, directly use the first child as ContentChild
  if (childrenArray[0].type === Header) {
    HeaderChild = /*#__PURE__*/React.cloneElement(childrenArray[0]);
    ContentChild = childrenArray.length > 1 ? /*#__PURE__*/React.cloneElement(childrenArray[1], {
      Header: HeaderChild
    }) : null;
  } else {
    ContentChild = /*#__PURE__*/React.cloneElement(childrenArray[0]);
  }
  return /*#__PURE__*/React.createElement(CustomTag, {
    className: className,
    "data-spacer": dataSpacer
  }, ContentChild);
};
Carousel.propTypes = {
  children: arrayOf(element).isRequired,
  as: string,
  dataSpacer: string,
  className: string
};
Carousel.defaultProps = {
  as: "div",
  dataSpacer: null,
  className: ""
};
Carousel.Content = Content;
Carousel.Header = Header;
Carousel.Item = Item;